import { render } from "./vueClipboard.vue?vue&type=template&id=735d0c52&scoped=true"
import script from "./vueClipboard.vue?vue&type=script&lang=js"
export * from "./vueClipboard.vue?vue&type=script&lang=js"

import "./vueClipboard.vue?vue&type=style&index=0&id=735d0c52&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735d0c52"]])

export default __exports__